<template>
  <div class="app-container">
    <list ref="list">
        <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" @click="add" >添加</el-button>
            <el-button type="primary" @click="save" plain>保存</el-button>
            <el-button type="danger" @click="del" >删除</el-button>
        </template>
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/finance/cashier/cashbanks/list'


export default {
  mixins: [curdMixins],
  components: {
    list,
  },
  data(){
    return {
    }
  },
  methods: {
    del(){
      this.$refs.list.onDelete();
    },
    
    create(){

    },
    save(){
      this.$refs.list.save()
    },
    add(){
      this.$refs.list.newLine();
    }
  }
  
};
</script>